import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import { BudgetOption as BudgetOptionType } from './constants'

interface BudgetOptionProps {
  value: string
  label: string
  isSelected: boolean
  onSelect: (value: BudgetOptionType) => void
}

export const BudgetOption: React.FC<BudgetOptionProps> = ({ value, label, isSelected, onSelect }) => (
  <button
    className={`${styles.budgetOption} ${isSelected ? styles.selected : ''}`}
    onClick={() => onSelect(value as BudgetOptionType)}
  >
    {label}
  </button>
)

BudgetOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}
